<template>
  <div>
    <div class="membership-tiers-body" v-if="tier">
      <div id="members">
        <b-img
          :src="require('@/assets/images/actions/back-button-circle.svg')"
          @click="$router.push({ name: 'membershipTiers' })"
          class="cursor-pointer"
          alt="Back"
        />
        <span id="title">List of Members</span>
        <b-row class="mt-3">
          <b-col class="members-card mx-3">
            <b-container>
              <b-row>
                <b-col
                  class="d-flex align-items-center justify-content-center"
                  cols="3"
                >
                  <b-img
                    :src="tier.badge_image_url"
                    alt="Tier Logo"
                    rounded="circle"
                    fluid
                  />
                </b-col>
                <b-col class="px-0">
                  <div class="secondary-label">Tier Name</div>
                  <div
                    class="primary-label"
                    style="
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ tier.name }}
                  </div>
                </b-col>
                <b-col
                  id="ellipsis-action"
                  cols="1"
                  class="text-right align-middle"
                >
                  <img
                    id="popover"
                    src="@/assets/images/icons/ellipsis-vertical.svg"
                    alt="Ellipsis Icon"
                    class="cursor-pointer"
                  />
                  <b-popover
                    target="popover"
                    triggers="click"
                    placement="bottomright"
                    class="px-0"
                    container="ellipsis-action"
                  >
                    <div
                      class="tier-action cursor-pointer pl-2 pr-5 py-2"
                      @click="getTier(tier.uuid, 'edit-membership-tier-modal')"
                    >
                      Edit
                    </div>
                  </b-popover>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
          <b-col class="members-card mx-3">
            <b-container>
              <b-row>
                <b-col
                  class="d-flex align-items-center justify-content-center"
                  cols="3"
                >
                  <b-img
                    :src="require('@/assets/images/icons/user-violet.png')"
                    alt="User"
                    fluid
                  />
                </b-col>
                <b-col class="px-0">
                  <div class="secondary-label">No. of members</div>
                  <div class="primary-label">{{ tier.total_members }}</div>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
          <b-col class="members-card mx-3">
            <b-container>
              <b-row>
                <b-col
                  class="d-flex align-items-center justify-content-center"
                  cols="3"
                >
                  <b-img
                    :src="require('@/assets/images/icons/points-orange.png')"
                    alt="Tier Logo"
                    rounded="circle"
                    fluid
                  />
                </b-col>
                <b-col class="px-0">
                  <div class="secondary-label">Total Points Requirement</div>
                  <span class="primary-label">{{ tier.points_requirement.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</span>
                  <span class="tertiary-label ml-2">PTS.</span>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <div>
              <div>
                <b-row>
                  <b-col sm="3" md="2" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                    <div class="filter-wrapper">
                      <b-form-select
                        v-model="selectedFilter"
                        :options="filterOptions"
                      />
                    </div>
                  </b-col>
                  <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                    <div class="filter-wrapper">
                      <b-input-group prepend>
                        <b-form-input
                          placeholder="Search"
                          v-model="keyword"
                          @input="setParam"
                        >
                        </b-form-input>
                        <b-dropdown
                          text="Advanced"
                          variant="primary"
                          slot="append"
                        >
                          <b-dropdown-item
                            v-for="(option, index) in advance_search_options"
                            :key="'advance_option_' + index"
                            @click="selectAdvanceOption(index)"
                          >
                            {{ option }}
                            <i
                              class="ml-1"
                              v-if="selected_advance_option === index"
                            >
                              <img
                                width="15"
                                height="15"
                                src="@/assets/images/checked-symbol.svg"
                                alt=""
                                class="mr-1"
                              />
                            </i>
                          </b-dropdown-item>
                        </b-dropdown>
                      </b-input-group>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <div>
                <div class="data-container">
                  <b-table
                    responsive
                    :items="memberListByTier"
                    :fields="fields"
                    show-empty
                    :empty-text="
                      isLoading ? 'Loading data' : 'No Records Found'
                    "
                    @row-hovered="onRowHovered"
                  >
                    <template slot="uuid" slot-scope="data">
                      <b-form-checkbox :value="data.value"> </b-form-checkbox>
                    </template>
                    <template slot="customer_name" slot-scope="data">
                      <span
                        class="customer-name"
                        v-b-modal="'edit-customer'"
                        @click="viewCustomer(data.item.customer_uuid)"
                        >{{ data.value }}</span
                      >
                    </template>
                    <template slot="action" slot-scope="data">
                      <div :id="`move-member-tier-container-${data.item.uuid}`">
                        <b-img
                          :src="
                            require('@/assets/images/icons/move-folder.png')
                          "
                          alt="Move Tier"
                          fluid
                          class="move-folder-image"
                          :id="`move-member-tier-${data.item.uuid}`"
                          tabindex="0"
                        />
                        <b-popover
                          :target="`move-member-tier-${data.item.uuid}`"
                          triggers="click"
                          placement="bottom"
                          :container="`move-member-tier-container-${data.item.uuid}`"
                        >
                          <!-- TIER START -->
                          <div v-show="!isShowSubTier">
                            <div class="title">Move to different tier</div>
                            <div class="tier-container">
                              <div
                                class="tier"
                                :class="{
                                  'selected-tier': selectedTier === tier,
                                }"
                                v-for="(tier, key) in tierList"
                                :key="key"
                                @click="selectTier(tier, data.item.id)"
                              >
                                <span class="mr-auto">{{ tier.name }}</span>
                                <img
                                  v-if="tier.sub_tiers.length"
                                  src="@/assets/images/caret-right-white.svg"
                                  alt="Carret Right"
                                />
                              </div>
                            </div>
                          </div>
                          <!-- TIER END -->
                          <!-- SUBTIER START -->
                          <div v-show="isShowSubTier">
                            <div class="title">
                              <img
                                src="@/assets/images/caret-left.svg"
                                alt="Back"
                                @click="isShowSubTier = false"
                                class="cursor-pointer"
                              />
                              <span class="ml-3">Select Sub Tier</span>
                            </div>
                            <div
                              class="tier-container"
                              v-if="selectedTier && selectedTier.sub_tiers"
                            >
                              <div
                                v-for="(subTier, key) in selectedTier.sub_tiers"
                                :key="key"
                                @click="selectedSubTier = subTier"
                                class="tier"
                                :class="{
                                  'selected-tier': selectedSubTier === subTier,
                                }"
                              >
                                {{ subTier.name }}
                              </div>
                            </div>
                          </div>
                          <!-- SUBTIER END -->
                          <div class="action-container">
                            <b-button
                              v-if="!hasSubTiers || isShowSubTier"
                              class="btn-pill col-md-6"
                              variant="primary"
                              :disabled="
                                !selectedTier ||
                                (isShowSubTier && !selectedSubTier)
                              "
                              @click="onMoveMemberTier"
                            >
                              Move here
                            </b-button>
                            <b-button
                              v-else
                              class="btn-pill col-md-6"
                              variant="primary"
                              @click="isShowSubTier = true"
                            >
                              Open sub tiers
                            </b-button>
                          </div>
                        </b-popover>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
              <div>
                <b-row>
                  <b-col>
                    <div class="mt-1">
                      <span class="pagination-indicator"
                        >Showing {{ pagination.currentFirstItem }} to
                        {{ pagination.currentLastItem }} of
                        {{ pagination.maxPage }} page</span
                      >
                    </div>
                  </b-col>
                  <b-col>
                    <b-pagination
                      hide-goto-end-buttons
                      align="right"
                      size="md"
                      class="custom-pagination"
                      :total-rows="
                        pagination.totalPerPage > 0
                          ? pagination.maxPage * pagination.totalPerPage
                          : 1
                      "
                      :limit="pagination.totalPerPage > 0 ? 5 : 1"
                      :per-page="pagination.totalPerPage"
                      v-model="pagination.currentPage"
                      @change="paginate"
                    >
                    </b-pagination>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <EditMembershipTierModal />
      <UploadBadgeModal :previous-modal="previousModal" />
    </div>
    <div class="content-body customers-wrapper customer-list">
      <b-modal
        id="edit-customer"
        size="lg modal-xlg"
        title="Customer Profile"
        @show="customerModal"
        @shown="customerModal"
        @hide="customerModalClose"
        hide-footer
      >
        <b-container fluid>
          <b-row>
            <b-col md="3">
              <div class="profile-wrap text-center">
                <div class="profile-img mb-2 d-inline-flex position-relative">
                  <img
                    :src="customer.profile_image"
                    alt=""
                    ref="customerProfileImg"
                    class="position-absolute"
                    :class="{
                      'max-w100': customerModalImg.hGw,
                      'max-h100': customerModalImg.wGh,
                    }"
                  />
                </div>
                <p class="profile-name text-center mb-2">
                  {{ customer.firstname }} {{ customer.lastname }}
                </p>
              </div>
              <div class="profile-box mt-3 mb-3">
                <div class="box-icon transactions"></div>
                <div class="box-details">
                  <div class="box-title">Transaction Count</div>
                  <div
                    class="box-value"
                    :value="getCustomerTransactionCount(customer.uuid)"
                  >
                    {{ historyCount }}
                  </div>
                </div>
              </div>
              <div class="profile-box mt-3 mb-3">
                <div class="box-icon peso"></div>
                <div class="box-details">
                  <div class="box-title">Amount Spent</div>
                  <div class="box-value">{{ amountSpent }}</div>
                </div>
              </div>
              <div class="profile-box mt-3 mb-3">
                <div class="box-icon points"></div>
                <div class="box-details">
                  <div class="box-title">Current Total Points</div>
                  <div class="box-value">{{ currentBalance }}</div>
                  <hr />
                  <div class="box-title">Points Earned</div>
                  <div class="box-value">{{ pointEarned }}</div>
                  <hr />
                  <div class="box-title">Points Redeemed</div>
                  <div class="box-value">{{ pointsRedeemed }}</div>
                </div>
              </div>
            </b-col>
            <b-col md="9">
              <div class="profile-tabs">
                <b-tabs>
                  <b-tab title="Profile Details" active>
                    <customer-profile-tab
                      v-bind:profile="form"
                      :merchantUuid="merchantUuid"
                      v-if="customer.uuid"
                      :key="customer.uuid"
                    >
                    </customer-profile-tab>
                  </b-tab>
                </b-tabs>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-modal>
    </div>
    <ConfirmMoveMemberTierModal
      :selectedTier="selectedTier"
      :selectedSubTier="selectedSubTier"
      :selectedMemberId="selectedMemberId"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import CustomerProfile from "../customers/CustomerProfileTab";
import EditMembershipTierModal from "./membership-tier/EditMembershipTierModal";
import UploadBadgeModal from "./membership-tier/UploadBadgeModal";
import ConfirmMoveMemberTierModal from "./membership-tier/ConfirmMoveMemberTierModal";

export default {
    name: "MembershipTiersMembers",
    props: ["uuid"],
    components: {
        "customer-profile-tab": CustomerProfile,
        EditMembershipTierModal,
        UploadBadgeModal,
        ConfirmMoveMemberTierModal
    },
    data() {
        return {
            selectedFilter: "all",
            filterOptions: [{ value: "all", text: "All Sub-Tiers" }],
            advance_search_options: {
                all: "All",
                customer_name: "Member Name",
                "sub_tiers.name": "Sub-Tier Name"
            },
            selected_advance_option: "all",
            fields: [
                {
                    key: "uuid",
                    label: ""
                },
                {
                    key: "customer_name",
                    label: "Member Name",
                    sortable: true
                },
                {
                    key: "sub_tier_name",
                    sortable: true,
                    label: "Sub-Tier Name"
                },
                {
                    key: "points",
                    sortable: true
                },
                {
                    key: "expiry_date",
                    sortable: true
                },
                "action"
            ],
            pageFirstItem: 1,
            pageLastItem: 2,
            maxPage: 10,
            keyword: "",
            customerModalImg: {
                hGw: false,
                wGh: false
            },
            previousModal: "",
            isShowSubTier: false,
            selectedTier: null,
            selectedSubTier: null,
            selectedMemberId: null
        };
    },
    computed: {
        ...mapState("programMembershipTiers", [
            "param",
            "tier",
            "isLoading",
            "pagination",
            "memberListByTier",
            "tierList"
        ]),
        ...mapState("customers", [
            "loading",
            "customer",
            "amountSpent",
            "currentBalance",
            "pointEarned",
            "pointsRedeemed",
            "form",
            "merchantUuid"
        ]),
        ...mapState("transactions", ["historyCount"]),
        hasSubTiers() {
            return this.selectedTier && this.selectedTier.sub_tiers.length;
        }
    },
    methods: {
        selectAdvanceOption: function(value) {
            this.selected_advance_option = value;
        },
        setParam: async function() {
            let param = {
                page: this.param.page,
                payload: {
                    tier_uuid: this.uuid,
                    sub_tier_id: null,
                    filters: {
                        keyword: this.keyword,
                        column: this.selected_advance_option
                    }
                }
            };
            this.$store.commit("programMembershipTiers/setParam", param);
            await this.$store.dispatch(
                "programMembershipTiers/getTier",
                this.uuid
            );
        },
        paginate: async function(page) {
            let param = {
                page: page,
                payload: this.param.payload
            };
            await this.$store.dispatch(
                "programMembershipTiers/getMemberListByTier",
                param
            );
        },
        viewCustomer(uuid) {
            this.$store.commit("customers/setUuid", uuid);
            this.$store.dispatch("customers/getProfile");
            this.$store.dispatch("customers/getPointsInfo");
            this.$store.dispatch("customers/getCardNumbers");
            this.$store.dispatch("customers/getCurrentBalance");

            // this.getStoreTransactions();
        },
        customerModal: function() {
            setTimeout(() => {
                let avatar_w = this.$refs.customerProfileImg.clientWidth;
                let avatar_h = this.$refs.customerProfileImg.clientHeight;
                avatar_w > avatar_h ? (this.customerModalImg.wGh = true) : null;
                avatar_h > avatar_w ? (this.customerModalImg.hGw = true) : null;
            }, 700);
        },
        customerModalClose: function() {
            this.customerModalImg.hGw = false;
            this.customerModalImg.wGh = false;
            this.form.birthdate = "0000-00-00";
        },
        getCustomerTransactionCount(uuid) {
            let param = {
                uuid: uuid
            };

            if (uuid != null)
                this.$store.dispatch(
                    "transactions/getCustomerHistoryCount",
                    param
                );
        },
        getTier: async function(id, previousModal) {
            this.previousModal = previousModal;
            let _this = this;
            await this.$store
                .dispatch("programMembershipTiers/getTier", id)
                .then(function() {
                    _this.$root.$emit(
                        "bv::show::modal",
                        "edit-membership-tier-modal"
                    );
                    _this.$root.$emit("bv::hide::popover");
                });
        },
        onRowHovered() {
            this.$root.$emit("bv::hide::popover");
            this.selectedTier = null;
            this.selectedSubTier = null;
            this.isShowSubTier = false;
        },
        selectTier(tier, memberId) {
            this.selectedTier = tier;
            this.selectedMemberId = memberId;
        },
        onMoveMemberTier() {
            this.$nextTick(() => {
                this.$root.$emit(
                    "bv::show::modal",
                    "confirm-move-member-tier-modal"
                );
                this.$root.$emit("bv::hide::popover");
            });
        }
    },
    async created() {
        this.setParam();
        await this.$store.dispatch("programMembershipTiers/getTierList");
    },
    watch: {
        param: function(param) {
            this.$store.dispatch(
                "programMembershipTiers/getMemberListByTier",
                param
            );
        }
    }
};
</script>

<style>
</style>
